/** Carta de Convivencia usuarias — versión canónica Sprint 2 */
export const CONVIVENCIA_CHARTER_VERSION = 'convivencia_v1_2026-05-15'

export const CONVIVENCIA_COMMITMENTS = [
  'Tratar a todas las compañeras con respeto y dignidad, en el piso y en la conversación.',
  'No discriminar por origen, orientación sexual, identidad de género, situación familiar, discapacidad o capacidad económica.',
  'Comunicar con honestidad sobre hábitos de convivencia, horarios y expectativas del hogar.',
  'Respetar la privacidad: no compartir datos sensibles, fotos ni conversaciones de terceras sin su consentimiento.',
  'En caso de conflicto, dialogar primero y recurrir a la mediación gratuita de JUNTAS antes de romper la convivencia.',
  'Reportar comportamientos que pongan en riesgo la seguridad (acoso, transfobia, violencia) desde la app o al 016.',
  'Aceptar que JUNTAS puede suspender mi cuenta si incumplo gravemente este código, tras revisión humana.',
]

export const CONVIVENCIA_INTRO =
  'Antes de unirte a la red, firmas este código ético interno. No es un contrato de alquiler: es el compromiso sororal que nos permite confiar unas en otras.'
